
import posthog from 'posthog-js';
import Consent from './consent';

const PERSON_PROPERTIES = ['account_type', 'created_at', 'free_trial_expires_at', 'is_academic'];

// PostHog sets a cookie and browser storage, so it only starts once the visitor accepts
// analytics cookies in CookieYes (see consent.js), and stops again if they withdraw.
let started = false;
// the signed-in user, kept until PostHog starts so it can be identified then
let pendingUser = null;

function clearPostHogStorage() {
    const prefix = `ph_${process.env.POSTHOG_API_KEY}`;
    [window.localStorage, window.sessionStorage].forEach((storage) => {
        try {
            Object.keys(storage).filter(key => key.indexOf(prefix) === 0).forEach(key => storage.removeItem(key));
        } catch (e) { /* storage unavailable */ }
    });
    document.cookie = `${prefix}_posthog=; Max-Age=0; path=/; domain=.${window.location.hostname.split('.').slice(-2).join('.')}`;
    document.cookie = `${prefix}_posthog=; Max-Age=0; path=/`;
}

function start() {
    posthog.init(process.env.POSTHOG_API_KEY, {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'identified_only', // Recommended for privacy
        session_recording: {
            maskAllInputs: true, // Privacy by default
            maskTextSelector: ".ph-no-capture" // Allow manual masking class
        },
        autocapture: true,
        capture_pageview: false, // We will handle this manually for React Router v3
        loaded: (posthog) => {
            // Register the environment super property for filtering
            posthog.register({
                environment: process.env.NODE_ENV === 'production' ? 'production' : 'local'
            });

            if (process.env.NODE_ENV !== 'production') {
                posthog.debug();
            }
        }
    });
    started = true;
    if (pendingUser) PostHogService.identifyUser(pendingUser);
}

const PostHogService = {
    init: () => {
        if (typeof window === 'undefined' || !process.env.POSTHOG_API_KEY) return;

        Consent.onAnalyticsChange((allowed) => {
            if (allowed && !started) {
                start();
            } else if (allowed) {
                posthog.opt_in_capturing();
            } else if (started) {
                posthog.opt_out_capturing();
                clearPostHogStorage();
            }
        });
    },

    capture: (eventName, properties) => {
        if (started) {
            posthog.capture(eventName, properties);
        }
    },

    // Links this browser to the user's account. Only the fields in PERSON_PROPERTIES are
    // sent: never the email, name or session token that also sit in the user data.
    identifyUser: (user) => {
        pendingUser = user || null;
        if (started && user && user.id) {
            const properties = {};
            PERSON_PROPERTIES.forEach((key) => {
                if (user[key] !== undefined) properties[key] = user[key];
            });
            posthog.identify(String(user.id), properties);
        }
    },

    reset: () => {
        pendingUser = null;
        if (started) {
            posthog.reset();
        }
    },

    isFeatureEnabled: (flagKey) => {
        if (started) {
            return posthog.isFeatureEnabled(flagKey);
        }
        return false;
    },

    onFeatureFlags: (callback) => {
        if (started) {
            posthog.onFeatureFlags(callback);
        }
    }
};

export default PostHogService;
